import type { StreamingChatId } from "@storytell/streaming";
import { For, Show, createEffect, createMemo } from "solid-js";
import { useWire } from "~/wire";
import { MessageRenderer } from "./MessageRenderer";

export const ChatRenderer = (props: { chatId: StreamingChatId }) => {
  const wire = useWire();
  const stream = wire.stream;

  const chat = () => stream.chat.get(props.chatId);

  let oldChatId = undefined as StreamingChatId | undefined;
  let oldMessagesLenght = undefined as number | undefined;
  createEffect(() => {
    const messagesLength = chat()?.messages.length;
    if (oldChatId === props.chatId && oldMessagesLenght === messagesLength) return;

    oldChatId = props.chatId;
    oldMessagesLenght = messagesLength;

    const els = Array.from(document.querySelectorAll("[data-message-renderer]"));
    const lastEl = els.at(-1);
    if (!lastEl) return;

    lastEl.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  return (
    <div class="space-y-10 px-4">
      <For each={chat()?.messages}>
        {(messageId) => <MessageRenderer messageId={messageId} chatId={props.chatId} />}
      </For>
    </div>
  );
};
